module.exports = __webpack_public_path__ + "img/EXTERIOR-FRONX-BOOSTERGREEN-4.7eb4aa27.jpg";